import { useDeviceModeContext } from 'client/context/DeviceModeContext'
import * as types from 'common/types'
import PropTypes from 'prop-types'
import React from 'react'
import { GroupTitle } from 'src/editor/layout/sidebar/settings/group-title'
import { ColorPickerControl } from 'src/editor/shared/settings/controls/color-picker/color-picker-control'
import { Input } from '../components'
import ButtonIconPicker from '../components/ButtonIconPicker'
import TextFont from '../components/Font/TextFont'
import HoverButtonSetting from '../components/HoverButton'
import { Attributes, FontSize } from '../options'
import {
  BorderStyle,
  CornerStyle,
  MarginsStyle,
  PaddingStyle,
  ShadowStyle,
} from '../styles'
import ButtonWidth from '../styles/ButtonWidth'
import FlexAlignStyle from '../styles/FlexAlignStyle'
import LineHeight from '../styles/LineHeight'

function PaymentButtonSettings(props) {
  const {
    entity,
    update,
    updateStyle,
    updateMobileStyle,
    updateOption,
    updateMobileOption,
    updateOptions,
    updateMobileOptions,
    toggleOverlay,
    overlayVisible,
  } = props

  const { isMobile } = useDeviceModeContext()

  const handleTextFontChange = fontProperties => {
    const updatedEntity = { ...entity }
    if (isMobile) {
      if (fontProperties.fontFileId) {
        delete updatedEntity.mobileStyles.fontWeight
        delete updatedEntity.mobileStyles.fontStyle
        update({
          ...updatedEntity,
          mobileStyles: {
            ...updatedEntity.mobileStyles,
            fontFamily: fontProperties.fontFamily,
          },
          mobileOptions: {
            ...updatedEntity.mobileOptions,
            textFontFileId: fontProperties.fontFileId,
          },
        })
      } else {
        if (
          updatedEntity.mobileOptions &&
          updatedEntity.mobileOptions.textFontFileId
        ) {
          delete updatedEntity.mobileOptions.textFontFileId
        }
        if (fontProperties.fontFamily === 'inherit') {
          delete updatedEntity.mobileStyles.fontWeight
          delete updatedEntity.mobileStyles.fontStyle
        }
        update({
          ...updatedEntity,
          mobileStyles: {
            ...updatedEntity.mobileStyles,
            ...fontProperties,
          },
        })
      }
    } else {
      if (fontProperties.fontFileId) {
        delete updatedEntity.styles.fontWeight
        delete updatedEntity.styles.fontStyle
        update({
          ...updatedEntity,
          styles: {
            ...updatedEntity.styles,
            fontFamily: fontProperties.fontFamily,
          },
          options: {
            ...updatedEntity.options,
            textFontFileId: fontProperties.fontFileId,
          },
        })
      } else {
        if (updatedEntity.options.textFontFileId) {
          delete updatedEntity.options.textFontFileId
        }
        if (fontProperties.fontFamily === 'inherit') {
          delete updatedEntity.styles.fontWeight
          delete updatedEntity.styles.fontStyle
        }
        update({
          ...updatedEntity,
          styles: {
            ...updatedEntity.styles,
            ...fontProperties,
          },
        })
      }
    }
  }

  const handleSubTextFontChange = fontProperties => {
    const updatedEntity = { ...entity }
    if (isMobile) {
      if (fontProperties.fontFileId) {
        update({
          ...updatedEntity,
          mobileOptions: {
            ...updatedEntity.mobileOptions,
            subTextFontFileId: fontProperties.fontFileId,
            subTextFontFamily: fontProperties.fontFamily,
          },
        })
      } else {
        updateMobileOptions({
          ...updatedEntity.options,
          subTextFontFamily: fontProperties.fontFamily,
          subTextFontStyle: fontProperties.fontStyle,
          subTextFontWeight: fontProperties.fontWeight,
        })
      }
    } else {
      if (fontProperties.fontFileId) {
        update({
          ...updatedEntity,
          options: {
            ...updatedEntity.options,
            subTextFontFileId: fontProperties.fontFileId,
            subTextFontFamily: fontProperties.fontFamily,
          },
        })
      } else {
        updateOptions({
          ...updatedEntity.options,
          subTextFontFamily: fontProperties.fontFamily,
          subTextFontStyle: fontProperties.fontStyle,
          subTextFontWeight: fontProperties.fontWeight,
        })
      }
    }
  }

  function updateTagOption(option) {
    const updatedEntity = { ...entity }

    if (!option) {
      return
    }
    updateOptions({
      ...updatedEntity.options,
      tagId: option.value,
    })
  }

  const textFontFamily = isMobile
    ? entity.mobileStyles.fontFamily
    : entity.styles.fontFamily
  const textFontWeight = isMobile
    ? entity.mobileStyles.fontWeight
    : entity.styles.fontWeight
  const textFontStyle = isMobile
    ? entity.mobileStyles.fontStyle
    : entity.styles.fontStyle

  const subTextFontFamily = isMobile
    ? entity.mobileOptions.subTextFontFamily
    : entity.options.subTextFontFamily
  const subTextFontWeight = isMobile
    ? entity.mobileOptions.subTextFontWeight
    : entity.options.subTextFontWeight
  const subTextFontStyle = isMobile
    ? entity.mobileOptions.subTextFontStyle
    : entity.options.subTextFontStyle

  return (
    <React.Fragment>
      <FlexAlignStyle
        align={entity.styles.alignSelf}
        mobileAlign={entity.mobileStyles.alignSelf}
        update={updateStyle('alignSelf')}
        mobileUpdate={updateMobileStyle('alignSelf')}
      />
      <ButtonWidth
        update={updateStyle('width')}
        mobileUpdate={updateMobileStyle('width')}
        width={entity.styles.width}
        mobileWidth={entity.mobileStyles.width}
      />
      <Input
        labelText="loading text"
        value={entity.options.loadingText}
        update={updateOption('loadingText')}
      />
      <Input
        labelText="button text"
        value={entity.options.text}
        update={updateOption('text')}
      />
      <Input
        labelText="entity_settings.button.sub_text.label"
        update={updateOption('subText')}
        value={entity.options.subText}
      />
      {/* Open when backend is ready for tags in buttons */}
      {/* <ReactSelect
        update={updateTagOption}
        options={userTags}
        labelText="entity_settings.button.add_tag_title"
        selectedOption={getSelectedTagOption(userTags, entity.options.tagId)}
        isMulti={false}
      /> */}
      <GroupTitle>typography</GroupTitle>
      <FontSize
        update={updateStyle('fontSize', 'px')}
        mobileUpdate={updateMobileStyle('fontSize', 'px')}
        fontSize={entity.styles.fontSize}
        mobileFontSize={entity.mobileStyles.fontSize}
      />
      <LineHeight
        lineHeight={entity.styles.lineHeight}
        mobileLineHeight={entity.mobileStyles.lineHeight}
        update={updateStyle('lineHeight', 'px')}
        mobileUpdate={updateMobileStyle('lineHeight', 'px')}
      />
      {entity.options.subText && (
        <FontSize
          labelText="entity_settings.button.sub_text.font_size.label"
          update={updateOption('subTextFontSize', 'px')}
          mobileUpdate={updateMobileOption('subTextFontSize', 'px')}
          fontSize={entity.options.subTextFontSize}
          mobileFontSize={entity.mobileOptions.subTextFontSize}
        />
      )}
      <TextFont
        fontFamily={textFontFamily}
        fontStyle={textFontStyle}
        fontWeight={textFontWeight}
        update={handleTextFontChange}
      />
      {entity.options.subText && (
        <TextFont
          labelText="entity_settings.button.sub_text.font_family.label"
          fontFamily={subTextFontFamily}
          fontStyle={subTextFontStyle}
          fontWeight={subTextFontWeight}
          update={handleSubTextFontChange}
        />
      )}
      <ButtonIconPicker
        valueBefore={entity.options.iconClassNameBefore}
        valueAfter={entity.options.iconClassNameAfter}
        updateBefore={updateOption('iconClassNameBefore')}
        updateAfter={updateOption('iconClassNameAfter')}
      />
      <MarginsStyle
        marginTop={entity.styles.marginTop}
        marginRight={entity.styles.marginRight}
        marginBottom={entity.styles.marginBottom}
        marginLeft={entity.styles.marginLeft}
        mobileMarginTop={entity.mobileStyles.marginTop}
        mobileMarginRight={entity.mobileStyles.marginRight}
        mobileMarginBottom={entity.mobileStyles.marginBottom}
        mobileMarginLeft={entity.mobileStyles.marginLeft}
        update={updateStyle}
        mobileUpdate={updateMobileStyle}
      />
      <GroupTitle>color</GroupTitle>
      <ColorPickerControl
        label="background color"
        update={updateStyle('backgroundColor')}
        mobileUpdate={updateMobileStyle('backgroundColor')}
        mobileColor={entity.mobileStyles.backgroundColor}
        color={entity.styles.backgroundColor}
      />
      <ColorPickerControl
        label="text color"
        update={updateStyle('color')}
        mobileUpdate={updateMobileStyle('color')}
        color={entity.styles.color}
        mobileColor={entity.mobileStyles.color}
      />
      {entity.options.subText && (
        <ColorPickerControl
          label="entity_settings.button.sub_text.color.label"
          update={updateOption('subTextColor')}
          mobileUpdate={updateMobileOption('subTextColor')}
          color={entity.options.subTextColor}
          mobileColor={entity.mobileOptions.subTextColor}
        />
      )}
      <PaddingStyle
        mobilePadding={entity.mobileStyles.padding}
        padding={entity.styles.padding}
        update={updateStyle('padding')}
        mobileUpdate={updateMobileStyle('padding')}
      />
      <CornerStyle
        topLeft={entity.styles.borderTopLeftRadius}
        topRight={entity.styles.borderTopRightRadius}
        bottomRight={entity.styles.borderBottomRightRadius}
        bottomLeft={entity.styles.borderBottomLeftRadius}
        mobileTopLeft={entity.mobileStyles.borderTopLeftRadius}
        mobileTopRight={entity.mobileStyles.borderTopRightRadius}
        mobileBottomLeft={entity.mobileStyles.borderBottomLeftRadius}
        mobileBottomRight={entity.mobileStyles.borderBottomRightRadius}
        update={updateStyle}
        mobileUpdate={updateMobileStyle}
      />
      <ShadowStyle
        shadow={entity.styles.boxShadow}
        mobileShadow={entity.mobileStyles.boxShadow}
        update={updateStyle('boxShadow')}
        mobileUpdate={updateMobileStyle('boxShadow')}
      />
      <HoverButtonSetting
        textColor={entity.styles.color}
        backgroundColor={entity.styles.backgroundColor}
        subTextColor={entity.styles.subTextColor}
        update={updateOption('hover')}
        mobileUpdate={updateMobileOption('hover')}
        hover={entity.options.hover}
        mobileHover={entity.mobileOptions.hover}
      />
      <BorderStyle
        updateOption={updateOption}
        updateMobileOption={updateMobileOption}
        updateStyle={updateStyle}
        updateMobileStyle={updateMobileStyle}
        type={entity.options.borderType}
        style={entity.styles.borderStyle}
        width={entity.styles.borderWidth}
        color={entity.styles.borderColor}
        mobileType={entity.mobileOptions.borderType}
        mobileStyle={entity.mobileStyles.borderStyle}
        mobileWidth={entity.mobileStyles.borderWidth}
        mobileColor={entity.mobileStyles.borderColor}
        toggleOverlay={toggleOverlay}
        overlayVisible={overlayVisible}
      />
      <Attributes update={updateOption} entity={entity} />
    </React.Fragment>
  )
}

PaymentButtonSettings.propTypes = {
  toggleOverlay: PropTypes.func.isRequired,
  overlayVisible: PropTypes.bool.isRequired,
  entity: types.entity.isRequired,
  updateStyle: PropTypes.func.isRequired,
  updateMobileStyle: PropTypes.func.isRequired,
  updateOption: PropTypes.func.isRequired,
  updateMobileOption: PropTypes.func.isRequired,
}

export default PaymentButtonSettings
